var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.paramValue!=null)?_c('div',{staticClass:"py-1 px-2 border rounded bg-darkgray"},[_c('h5',{staticClass:"param-value font-weight-bolder m-0 text-uppercase text-lg"},[_vm._v("\n    "+_vm._s(_vm.__('favorites.filters.' + _vm.paramValue). indexOf('.') == -1 ?  _vm.__('favorites.filters.' + _vm.paramValue) : _vm.paramValue)+"\n  ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }